import PageHero from "@/components/site/PageHero";
import { BlogCard, useBlogs } from "@/components/site/BlogTeaser";
import { usePageMeta } from "@/components/site/usePageMeta";
import { useLang } from "@/i18n/LangContext";

export default function Blog() {
  const { tr } = useLang();
  usePageMeta(
    tr("Dental Blog – San Juan del Sur & Nicaragua Dental Guides", "Blog Dental – Guías Dentales de San Juan del Sur y Nicaragua"),
    tr("Guides on dental care in San Juan del Sur and Nicaragua: dental tourism, implants, Damon braces, Digital Smile Design and more from Dra. Cora Baltodano.", "Guías de salud dental en San Juan del Sur y Nicaragua: turismo dental, implantes, brackets Damon, Diseño de Sonrisa Digital y más, por la Dra. Cora Baltodano."),
    tr("dental blog Nicaragua, San Juan del Sur dentist, dental tourism Nicaragua", "blog dental Nicaragua, dentista San Juan del Sur, turismo dental Nicaragua")
  );
  const blogs = useBlogs();
  return (
    <>
      <PageHero eyebrow={tr("The Blog", "El Blog")} title={tr(<>Smile guides for <span className="text-[#00C9B7]">San Juan del Sur</span> & Nicaragua</>, <>Guías de sonrisa para <span className="text-[#00C9B7]">San Juan del Sur</span> y Nicaragua</>)} img="/img/sjds-town.jpg" />
      <section className="pb-24 sm:pb-32">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-3 gap-6" data-testid="blog-list">
          {blogs === null && [...Array(3)].map((_, i) => <div key={i} className="h-96 rounded-3xl bg-[#131B21] animate-pulse" />)}
          {blogs?.map((b, i) => <BlogCard key={b.id} b={b} i={i} big={i === 0} />)}
        </div>
      </section>
    </>
  );
}
